import React, { FC, useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Button, HeaderFeatureIntro, Icon, LinkButton, Modal } from 'src/components';
import { ROUTES } from 'src/constants/routes.const';
import * as S from './styles';

const msgs = defineMessages({
  introTitle: {
    id: 'myWords_intro_title',
  },
  introDescription: {
    id: 'myWords_intro_description',
  },
  newFeatureTitle: {
    id: 'onboarding_coreLoopUsersToProgress_MyWords_title',
  },
  newFeatureDescription: {
    id: 'onboarding_coreLoopUsersToProgress_MyWords_description1',
  },
  newFeatureNote: {
    id: 'onboarding_coreLoopUsersToProgress_MyWords_description2',
  },
  primaryCta: {
    id: 'myWords_intro_mainCTA',
  },
  secondaryCta: {
    id: 'myWords_intro_secondaryCTA',
  },
});

export const MyWordsIntroModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  contentVariant?: 'intro' | 'new-feature';
  progressIndicator?: string;
}> = ({ isOpen, onClose, contentVariant = 'intro', progressIndicator }) => {
  const intl = useIntl();

  const content = useMemo(
    () =>
      contentVariant === 'new-feature' ? (
        <>
          <S.ModalHeader>{intl.formatMessage(msgs.newFeatureTitle)}</S.ModalHeader>
          <S.Description>{intl.formatMessage(msgs.newFeatureDescription)}</S.Description>
          <S.Note>{intl.formatMessage(msgs.newFeatureNote)}</S.Note>
        </>
      ) : (
        <>
          <S.ModalHeader>{intl.formatMessage(msgs.introTitle)}</S.ModalHeader>
          <S.Description>{intl.formatMessage(msgs.introDescription)}</S.Description>
        </>
      ),
    [contentVariant, intl],
  );

  return (
    <Modal hideCloseButton isOpen={isOpen} data-testid="my-words-intro-modal">
      <S.ModalContent>
        <HeaderFeatureIntro feature="my-words" />

        <S.ModalBody>{content}</S.ModalBody>

        <S.ModalFooter>
          <S.ButtonWrapper>
            <LinkButton
              buttonSize="medium"
              buttonType="primary"
              href={ROUTES.myWords}
              onClick={onClose}
              data-testid="tooltip_myword_btn"
              wide
            >
              <S.PrimaryButtonContent>
                <Icon name="book" />
                {intl.formatMessage(msgs.primaryCta)}
              </S.PrimaryButtonContent>
            </LinkButton>
          </S.ButtonWrapper>

          <S.ButtonWrapper>
            <Button
              buttonSize="large"
              buttonType="secondary"
              onClick={onClose}
              data-testid="tooltip_maybelater_btn"
              wide
            >
              {intl.formatMessage(msgs.secondaryCta)}
            </Button>
          </S.ButtonWrapper>
        </S.ModalFooter>
        {progressIndicator && <S.ProgressIndicator>{progressIndicator}</S.ProgressIndicator>}
      </S.ModalContent>
    </Modal>
  );
};
